import { useEffect, useRef } from 'react';

const useRefresh = (callback: () => void, depsArray: any[] = []) => {
  const savedCallback = useRef(callback);

  // Эт для сохранения последнего коллбека
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Содание интервала ток если depsArray изменился
  useEffect(() => {
    const intervalId = setInterval(() => {
      savedCallback.current();
    }, 15000);
    return () => clearInterval(intervalId);
    // Распространяем зависимости чтобы отслеживать каждое значение, а не ссылку на массив
  }, [...depsArray]);
};

export default useRefresh;
